import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearCurrentPage,
  getApiParams,
} from "../../../NetworkPortal/ProviderProfileDetails/helper";
import Select from "react-select";
import { useEffect } from "react";
import {
  CSVData,
  TestExcelHeader,
  TestExcelHeaderColmns,
  initialFilterState,
  initialHeaderTest,
} from "./helper";
import Modal from "react-modal";
import { SearchIcon } from "../../../../Utils/SvgIcons";
import { ChooseToFilterPackagePopup } from "./ChooseToFilterPackagePopup";
import { AddQuicklyPackageSKUPopup } from "./AddQuicklyPackageSKUPopup";
import PaginatedItems from "../../../../common/Pagination";
import { CSVLink } from "react-csv";
import {
  getSKUPackageNetworkExcelAction,
  getSkuPackagesNetworkAction,
} from "../../../../redux/actions/TestPackageNetworkAction";
import { getNetworkMenuId } from "../../../../Utils/types";
import { UploadExcelPackageNetworkPopup } from "./UploadExcelPackageNetworkPopup";

const Packages = ({selectTestPackages}) => {
  const dispatch = useDispatch();
  const [showHeaderTestArray, setShowHeaderTestArray] =
    useState(initialHeaderTest);
  const [excelSheetData, setExcelSheetData] = useState([]);
  const [userDetail, setUserDetail] = useState(null);
  const [isLoadingExcel, setIsLoadingExcel] = useState(false);
  const [isUploadExcel, setIsUploadExcel] = useState(false);
  const [searchFilter, setSearchFilter] = useState(initialFilterState);
  const [isAddSku, setIsAddSku] = useState(false);
  const [isChooseToFilter, setIsChooseToFilter] = useState(false);
  const [providerCanEdit,setProviderCanEdit] = useState(null)

  // const [multiSelect, setMultiSelect] = useState([]);
  // const [selectAll, setSelectAll] = useState(false);

  const TestPackageReducer = useSelector((state) => state?.TestPackageReducer);
  const globalReducer = useSelector((state) => state?.globalReducer);
  const { apiParams } = getApiParams({ globalReducer });
  const providerPortalDetailReducer = useSelector(
    (state) => state?.providerPortalDetailReducer
  );

  useEffect(() => {
    dispatch(getSkuPackagesNetworkAction({ ...searchFilter, ...apiParams }));
  }, [globalReducer?.getCurrentPage]);

  useEffect(() => {
    let value = getNetworkMenuId()?.informationPermissions.filter((ele)=> ele?.informationName === selectTestPackages)
    setProviderCanEdit(value[0])
  }, [selectTestPackages]);

  const handleSearch = () => {
    clearCurrentPage(dispatch);
    dispatch(
      getSkuPackagesNetworkAction({
        ...searchFilter,
        ...apiParams,
        page: 1,
      })
    );
  };

  const handleClearFilter = () => {
    setSearchFilter(initialFilterState);
    dispatch(getSkuPackagesNetworkAction(initialFilterState));
    clearCurrentPage(dispatch);
    // setMultiSelect([]);
    // setSelectAll(false);
  };

  const ExportToExcelHandler = async () => {
    setIsLoadingExcel(true);
    const resp = dispatch(
      getSKUPackageNetworkExcelAction({
        facilityId: searchFilter?.facilityId,
        providerId: searchFilter?.providerId,
        sortDirection: "desc",
        // providerFacilitiesIds: selectAll ? "" : multiSelect?.toString(),
      })
    );
    resp?.then((res) => {
      if (res?.data?.status === true) {
        setExcelSheetData(res?.data?.results);
        setIsLoadingExcel(false);
      } else {
        setIsLoadingExcel(false);
      }
      setTimeout(() => {
        document.getElementById("exportexcel").click();
      }, 500);
    });
  };

  const EditIconHandler = (ele) => {
    setIsAddSku(true);
    setUserDetail(ele);
  };

  // const providerFacilitiesIds =
  //   TestPackageReducer?.getSkuTestPackagesDetails?.lstSKUDetails?.map((ele) => {
  //     return ele?.changedemoId;
  //   });

  return (
    <>
      <div className="row-filter">
        <Select
          className="basic-multi-select custom-width-300"
          classNamePrefix="select"
          placeholder="Search HA Package Name or Code"
          name="colors"
          isClearable={true}
          options={providerPortalDetailReducer?.getFacilityReason?.map(
            (ele) => {
              return {
                value: ele?.facilityId,
                label: ele?.facilityName,
              };
            }
          )}
          styles={{
            menu: (provided) => ({ ...provided, zIndex: 9999 }),
          }}
          onChange={(e) => {
            setSearchFilter({
              ...searchFilter,
              facilityId: e === null ? 0 : e?.value,
              facilityName: e === null ? e : e?.label,
            });
          }}
          value={
            searchFilter?.facilityId
              ? {
                  value: searchFilter?.facilityId,
                  label: searchFilter?.facilityName,
                }
              : null
          }
        />
        <Select
          className="basic-multi-select custom-width-300"
          style={{ width: "300px" }}
          classNamePrefix="select"
          placeholder="Search Provider Name or Code"
          name="colors"
          isClearable={true}
          styles={{
            menu: (provided) => ({ ...provided, zIndex: 9999 }),
          }}
          options={TestPackageReducer?.getProviderListNetworkDetails?.map(
            (ele) => {
              return {
                value: ele?.providerId,
                label: ele?.providerName,
              };
            }
          )}
          onChange={(e) => {
            setSearchFilter({
              ...searchFilter,
              providerId: e === null ? 0 : e?.value,
              providerName: e === null ? e : e?.label,
            });
          }}
          value={
            searchFilter?.providerId
              ? {
                  value: searchFilter?.providerId,
                  label: searchFilter?.providerName,
                }
              : null
          }
        />
        <div className="search" type="button" onClick={handleSearch}>
          <a className="sidebar-links">
            <SearchIcon />
            <span className="sidebar-link-text">Search</span>
          </a>
        </div>
        <div className="search" type="button" onClick={handleClearFilter}>
          <a className="sidebar-links">
            <span className="sidebar-link-text">Clear All</span>
          </a>
        </div>
      </div>
      <div className="row-results">
        <div className="d-flex gap-10">
          <select
            className="row-selectdropdown"
            value={searchFilter?.rows}
            onChange={(e) => {
              clearCurrentPage(dispatch);
              setSearchFilter({
                ...searchFilter,
                page: 1,
                rows: e.target.value,
              });
              dispatch(
                getSkuPackagesNetworkAction({
                  ...searchFilter,
                  rows: e.target.value,
                  page: 1,
                })
              );
            }}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
          </select>
          <p className="results">
            Total <span>{globalReducer?.getTotalCount}</span> results
          </p>
        </div>
        {/* <div>
          {multiSelect?.length ? (
            <div className="select_all_div">
              {!selectAll && (
                <>
                  <p>{multiSelect?.length} packages are selected</p>
                  <span
                    className="select_all_primary_cases"
                    onClick={() => setSelectAll(true)}
                  >
                    Select all {globalReducer?.getTotalCount} packages
                  </span>
                </>
              )}
              {selectAll && (
                <p>{globalReducer?.getTotalCount} packages are selected</p>
              )}
            </div>
          ) : null}
        </div> */}
        <div className="d-flex gap-10">
          {providerCanEdit?.canEdit && (
            <button
              className={`btn search__btn`}
              type="button"
              onClick={() => {
                setIsAddSku(true);
                setUserDetail(null);
              }}
            >
              <i className="fa-solid fa-plus pt-1 c-white"></i>&nbsp;
              {window.innerWidth <= 700 ? "Add" : "Quickly Add Package"}
            </button>
          )}
          <button
            className={`btn ${
              !isLoadingExcel ? "search__btn" : "disabled_btn"
            }`}
            type="button"
            onClick={!isLoadingExcel && ExportToExcelHandler}
            // disabled={!multiSelect?.length}
          >
            <i className="fa-solid fa-arrow-down"></i>&nbsp;
            {isLoadingExcel
              ? window.innerWidth <= 700
                ? "Export"
                : "Exporting..."
              : window.innerWidth <= 700
              ? "Excel"
              : "Export To Excel"}
          </button>
          <CSVLink
            style={{ display: "none" }}
            id="exportexcel"
            data={CSVData(excelSheetData)}
            headers={TestExcelHeader}
            filename={"providerpackagedetails.csv"}
          ></CSVLink>
          {providerCanEdit?.canEdit && <button
            className={`btn search__btn`}
            type="button"
            onClick={() => setIsUploadExcel(true)}
          >
            <i className="fas fa-file-upload pt-1"></i>&nbsp;
            {window.innerWidth <= 700 ? "Import" : "Import Package"}
          </button> }
          
        </div>
      </div>
      <div className="table-responsive __custom__properties">
        <table className="table">
          <thead>
            <tr className="avanishtbl">
              {/* <th>
                <input
                  type="checkbox"
                  onClick={(e) =>
                    e?.target?.checked
                      ? (setSelectAll(false),
                        setMultiSelect([
                          ...new Set(
                            [
                              ...multiSelect,
                              ...TestPackageReducer?.getSkuTestPackagesDetails?.lstSKUDetails?.map(
                                (ele) => {
                                  return ele?.changedemoId;
                                }
                              ),
                            ].map((item) => item)
                          ),
                        ]))
                      : (setSelectAll(false),
                        setMultiSelect(
                          multiSelect?.length === 10
                            ? []
                            : multiSelect?.filter(
                                (item) => !providerFacilitiesIds.includes(item)
                              )
                        ))
                  }
                  checked={providerFacilitiesIds?.every((r) =>
                    multiSelect?.includes(r)
                  )}
                  className="form-check-input"
                  readOnly
                />
              </th> */}
              {showHeaderTestArray?.map((ele, index) => {
                return (
                  <th scope="col" key={index}>
                    {ele}
                  </th>
                );
              })}
              <th
                style={{ cursor: "pointer" }}
                onClick={() => setIsChooseToFilter(true)}
              >
                <img src="./../images/settings.png" alt="" />
              </th>
            </tr>
          </thead>
          <tbody>
            {TestPackageReducer?.getSkuTestPackagesDetails?.lstSKUDetails?.map(
              (ele, index) => {
                return (
                  <tr key={index}>
                    {/* <td>
                      <input
                        type="checkbox"
                        onClick={(e) =>
                          e?.target?.checked
                            ? (setSelectAll(false),
                              setMultiSelect([
                                ...multiSelect,
                                ele?.changedemoId,
                              ]))
                            : (setSelectAll(false),
                              setMultiSelect(
                                multiSelect.filter(
                                  (value) => value !== ele?.changedemoId
                                )
                              ))
                        }
                        checked={multiSelect?.some(
                          (element) => element === ele?.changedemoId
                        )}
                        className="form-check-input"
                        readOnly
                      />
                    </td> */}
                    {showHeaderTestArray?.map((col) => (
                      <td>
                        {col === "Gender"
                          ? ele?.gender === "M"
                            ? "Male"
                            : ele?.gender === "F"
                            ? "Female"
                            : "Both"
                          : col === "Fasting Required"
                          ? ele?.fastingRequired
                            ? "Yes"
                            : "No"
                          : ele[TestExcelHeaderColmns[col]] === null
                          ? "-"
                          : ele[TestExcelHeaderColmns[col]]}
                      </td>
                    ))}
                    <td
                      style={{
                        cursor: !providerCanEdit?.canEdit
                          ? "default"
                          : "pointer",
                      }}
                      onClick={() =>
                        !providerCanEdit?.canEdit
                          ? null
                          : EditIconHandler(ele)
                      }
                    >
                      <img src="./../images/edit-icon.png" alt="" />
                    </td>
                  </tr>
                );
              }
            )}
          </tbody>
        </table>
      </div>
      <div className="pagination-row">
        {globalReducer?.getTotalCount !== 0 && (
          <PaginatedItems
            totalCount={globalReducer?.getTotalCount}
            perPageData={searchFilter?.rows}
          />
        )}
      </div>
      <Modal
        isOpen={isAddSku}
        className="modal-add-user-popup modal-role-user-popup"
        overlayClassName="overlay-history-popup network-z-index"
        ariaHideApp={false}
      >
        <AddQuicklyPackageSKUPopup
          setIsAddSku={setIsAddSku}
          searchFilter={searchFilter}
          apiParams={apiParams}
          userDetail={userDetail}
        />
      </Modal>
      <Modal
        isOpen={isChooseToFilter}
        className="modal-add-user-popup modal-role-user-popup modal-choose-popup"
        overlayClassName="overlay-history-popup network-z-index"
        ariaHideApp={false}
      >
        <ChooseToFilterPackagePopup
          setIsChooseToFilter={setIsChooseToFilter}
          showHeaderTestArray={showHeaderTestArray}
          setShowHeaderTestArray={setShowHeaderTestArray}
        />
      </Modal>
      <Modal
        isOpen={isUploadExcel}
        className="modal-add-user-popup modal-upload-excel-popup"
        overlayClassName="overlay-history-popup network-z-index"
        ariaHideApp={false}
      >
        <UploadExcelPackageNetworkPopup setIsUploadExcel={setIsUploadExcel} />
      </Modal>
    </>
  );
};

export default Packages;
